// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"205":"post","624":"catalog","937":"member"}[chunkId] || chunkId) + "." + {"136":"8610aa74","205":"99ab519b","624":"3a787714","937":"55707099"}[chunkId] + ".js";
};